import { FinancerPendingDetailDTO, SelectedMovementDTO } from '../dto/FinancerDistributionDTO';
import { EHonorariumMovementType } from '../enums/EHonorariumMovementType';

/**
 * Identidad de un movimiento: tipo + detalle de orden + refacturación + comprobante de origen (los null cuentan).
 * No es única por fila: una anulación sobre dos ítems de la misma prestación repite la clave.
 */
export function movementKey(d: SelectedMovementDTO): string {
    return [d.movementType, d.benefitOrderDetailId, d.reinvoicingRequestId, d.sourceAdministrativeFormId]
        .map(part => (part == null ? 'null' : String(part)))
        .join('|');
}

export function toSelectedMovement(d: FinancerPendingDetailDTO): SelectedMovementDTO {
    return {
        movementType: d.movementType,
        benefitOrderDetailId: d.benefitOrderDetailId,
        reinvoicingRequestId: d.reinvoicingRequestId,
        sourceAdministrativeFormId: d.sourceAdministrativeFormId,
    };
}

/**
 * Filas que restan (anulaciones, créditos) de una ORDEN seleccionada que quedaron sin seleccionar:
 * rendirla sin ellas le paga de más al profesional. Solo ve las filas que se cargaron.
 */
export function findUnselectedNegatives(
    selectedKeys: ReadonlySet<string>,
    loadedRows: Iterable<FinancerPendingDetailDTO>,
): FinancerPendingDetailDTO[] {
    const rows = Array.from(loadedRows);
    const selectedOrderDetails = new Set(
        rows.filter(r => r.movementType === EHonorariumMovementType.ORDER && selectedKeys.has(movementKey(r)))
            .map(r => r.benefitOrderDetailId),
    );
    return rows.filter(r => r.professionalAmount < 0
        && selectedOrderDetails.has(r.benefitOrderDetailId)
        && !selectedKeys.has(movementKey(r)));
}
